import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { PersonSearchActivityComponent } from 'src/app/person-search/person-search-activity/person-search-activity.component';
import * as _ from "underscore";
declare const clevertap;
import moment from 'moment';

@Component({
    selector: 'app-company-comparison-ai',
    templateUrl: './company-comparison-ai.component.html',
    styleUrls: ['./company-comparison-ai.component.scss'],
    standalone: false
})
export class CompanyComparisonAiComponent implements OnInit {

  @Input() companyOne;
  @Input() companyTwo;
  @Input() companyOneAI;
  @Input() companyTwoAI;
  filterdata: any;
  aifilter: any;
  aiData: any;
  aiSummary: any;
  showShimmerLoader: boolean = false;
  aisubscription: Subscription;
  showGenerate: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  insightsExportSubscription: Subscription[] = [];
  @Output() sendAISummary: EventEmitter<any> = new EventEmitter();
  constructor(private companyInsightsService: CompanyInsightsService, private filterDataHandlerService: FilterDataHandlerService,
    private localStorageService: LocalStorageService, private personSearchService: PersonSearchService) { }

  ngOnInit() {
    this.showGenerate = false;
    const fetchcompanyAI = this.companyInsightsService.fetchCompanyComparisonForAI.subscribe((res) => this.fetchAIData(res));
    this.insightsExportSubscription.push(fetchcompanyAI)
    const insightsExport = this.companyInsightsService.fetchCompanyCompareExportData.subscribe((res) => {
      this.exportPdf(res);
    })
    this.insightsExportSubscription.push(insightsExport)
    if (!this.localStorageService.getItem('companyOneId') || !this.localStorageService.getItem('companyTwoId')) {
      this.showGenerate = true;
    }
  }

    ngOnDestroy() {
  this.insightsExportSubscription.forEach(sub => sub.unsubscribe());
  }



  fetchAIData(response) {
    this.aiSummary = '';
    this.showShimmerLoader = false;
    this.showGenerate = false;
    if (!this.localStorageService.getItem('companyOneId') || !this.localStorageService.getItem('companyTwoId')) {
      this.showGenerate = true;
    }
    this.getfilterdata();
    this.aiData = response;

  }

  getfilterdata() {
    this.filterdata = this.filterDataHandlerService.fetchFilterData;
    if (this.filterdata) {
      this.aifilter = {
        locations: this.filterdata && this.filterdata.locationSelectedList.length ? this.filterdata.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key) : [],
        functions: this.filterdata && this.filterdata.functionSelectedList ? this.filterdata.functionSelectedList.map(l => l.key) : [],
        jobtitles: this.filterdata && this.filterdata.jobTitleSelectedList.length ? _.uniq(this.filterdata.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)) : [],
        companies: this.filterdata && this.filterdata.companySelectedList.length ? this.filterdata.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key) : [],
        industries: this.filterdata && this.filterdata.industrySelectedList.length ? this.filterdata.industrySelectedList.map(industry => industry.key) : [],
        fromyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceFrom ? [this.filterdata.yearsofexperienceFrom] : [],
        toyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceTo ? [this.filterdata.yearsofexperienceTo] : [],
        schools: this.filterdata && this.filterdata.schoolSelectedList.length ? this.filterdata.schoolSelectedList.map(s => s.key) : [],
        degrees: this.filterdata && this.filterdata.educationSelectedList.length ? this.filterdata.educationSelectedList.map(e => e.key) : [],
        genders: this.filterdata && this.filterdata.gender ? [this.filterdata.gender] : [],
        seniorities: this.filterdata && this.filterdata.seniority.length ? this.filterdata.seniority : [],
        keywords:  this.filterdata && this.filterdata.keywordSelectedList.length ? this.filterdata.keywordSelectedList: [],

      }
      this.aiSummary = '';
      this.showShimmerLoader = false;
      if (this.aisubscription)
        this.aisubscription.unsubscribe();
    }
  }

  generateai() {
    this.showShimmerLoader = true;
    const payload = {
      companyname: this.aiData.companyname,
      insightstabname: "overview",
      data: {
        company_one: this.aiData.company_one,
        company_two: this.aiData.company_two
      },
      params: {
        company_one: this.aiData.paramcompany_one,
        company_two: this.aiData.paramcompany_two
      },
      filters: this.aifilter
    }
    this.aisubscription = this.companyInsightsService.getcompanyinsightssummary(payload).subscribe((res: any) => {
      this.aiSummary = res.data;
      this.sendAISummary.emit(this.aiSummary);
      this.showShimmerLoader = false;
      this.aiSummary = this.aiSummary.replace(/(?:\r\n|\r|\n)/g, '<br>');


      if (this.aisubscription)
        this.aisubscription.unsubscribe();
    })
  }

  getDisabledCompareButton(companyId) {
    const companyOneId = this.localStorageService.getItem('companyOneId');
    const companyTwoId = this.localStorageService.getItem('companyTwoId');
    if (companyOneId && companyTwoId)
      return true;
    else if ((companyOneId && companyOneId == companyId) && !companyTwoId)
      return true;
    else if (!companyOneId && (companyTwoId && companyTwoId == companyId))
      return true;
    else return false;
  }

  requestInsightsExport() {
    this.companyInsightsService.setCompanyExportData({ status: 'export' });

  }

  exportPdf(data) {
    const payload = data;
    const companyLogoPayload = [{ "name": data.companies[0].name }, { "name": data.companies[1].name }];
    this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        res.data.forEach((company) => {
          if (company.name == data.companies[0].name) {
            payload.companies[0].companylogo = company.companylogo;
          } else if (company.name == data.companies[1].name) {
            payload.companies[1].companylogo = company.companylogo;
          }
        })
           if(this.aiSummary) {
            payload['aiData'] = this.aiSummary;
        }
        const exportPayload = {
          data: payload,
        }
        this.companyInsightsService.exportInsights(exportPayload).subscribe((res: any) => {
          if (res) {
            if (res.status === 'failure') {
              this.errorMessage = 'Error occured while generating the report';
            } else {
                const talentpoolParams = {
                              "User ID": this.localStorageService.getItem('userdata').userid,
                              "Export Type": "Company Insights Compare",
                              "Export Complete": "Yes",
                              "Email Sent": "Yes",
                              "File Format": `Webbtree_CompanyInsights(${payload?.companies[0]?.name} vs ${payload?.companies[1]?.name}).pdf`,
                              "Timestamp": moment().format()
                            }
                            clevertap.event.push('Company Comparison Exported', talentpoolParams);
              this.successMessage = 'You will receive the company insights report on your email in a min.';
            }
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          } else {
            this.errorMessage = 'Error occured while generating the report';
          }
        }, () => {
          this.errorMessage = 'Error occured while generating the report';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 5000);
        })
      }
    })
  }
}
